var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "#1F1F33",
    stroke: "#3D2C5C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_547_4379",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_547_4379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 16.0208C15.1038 16.0208 14.3417 15.7066 13.7132 15.0781C13.0847 14.4497 12.7705 13.6875 12.7705 12.7917C12.7705 11.8958 13.0847 11.1337 13.7132 10.5052C14.3417 9.87674 15.1038 9.5625 15.9997 9.5625C16.8955 9.5625 17.6577 9.87674 18.2861 10.5052C18.9146 11.1337 19.2288 11.8958 19.2288 12.7917C19.2288 13.6875 18.9146 14.4497 18.2861 15.0781C17.6577 15.7066 16.8955 16.0208 15.9997 16.0208ZM9.52051 22.3958V20.1875C9.52051 19.7292 9.63683 19.3108 9.86947 18.9323C10.1021 18.5538 10.4163 18.2639 10.8122 18.0625C11.6594 17.6458 12.5153 17.3316 13.3799 17.1198C14.2445 16.908 15.1177 16.8021 15.9997 16.8021C16.8816 16.8021 17.7549 16.908 18.6195 17.1198C19.484 17.3316 20.34 17.6458 21.1872 18.0625C21.583 18.2639 21.8972 18.5538 22.1299 18.9323C22.3625 19.3108 22.4788 19.7292 22.4788 20.1875V22.3958H9.52051Z",
    fill: "#CCCCE0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f574fd57edda4bc841b8e0961a170a56.svg";
export { ForwardRef as ReactComponent };